/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHandlerConfigurationRequest {
    getFixupPrototypeFunction() { return BackgroundJobHandlerConfigurationRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHandlerConfigurationRequest>): BackgroundJobHandlerConfigurationRequest {
        let obj = Object.assign(new BackgroundJobHandlerConfigurationRequest(), model);
        BackgroundJobHandlerConfigurationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHandlerConfigurationRequest>): BackgroundJobHandlerConfigurationRequest {
        if (!model) return null;
        return BackgroundJobHandlerConfigurationRequest.newInstance(<BackgroundJobHandlerConfigurationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHandlerConfigurationRequest) {
        if (!obj) return;

        models.BackgroundJobHandlerConfigurationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHandlerConfigurationRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobHandlerConfigurationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Target executor
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Target payload type
     */
    payload_type: string;

}
